var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4235 40.619L20.6352 41.4992L22.0222 41.5701L24.9851 41.0852L27.989 40.3603L32.239 38.1177L36.6018 34.2472L37.4462 33.1554L38.9496 30.6109L40.3593 28.1328L40.9593 24.6113L41.4848 19.5949L39.8745 15.0391L37.318 10.2403L33.7689 6.91984L31.0805 5.31023L24.3249 3.42144L16.9184 4.38668L11.0787 7.2651L6.95592 11.1763L4.23368 15.0784L3.28649 18.7056L2.69279 24.1222L4.73295 31.4685L7.50396 35.9744L12.3736 39.2722L16.4235 40.619Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBg);
export default __webpack_public_path__ + "static/media/icon_bg.684acfe1.svg";
export { ForwardRef as ReactComponent };